import { motion } from "motion/react"
import { useState, useEffect } from "react"

interface DealingCardData {
  id: string
  toTop: string
  toLeft: string
}

interface DealingAnimationProps {
  seatPositions: { top: string; left: string }[]
  staggerMs?: number
  onComplete?: () => void
}

export function DealingAnimation({ seatPositions, staggerMs = 100, onComplete }: DealingAnimationProps) {
  const [cards, setCards] = useState<DealingCardData[]>([])

  useEffect(() => {
    // Two rounds of dealing: one card to each player per round
    const allCards: DealingCardData[] = []
    for (let round = 0; round < 2; round++) {
      for (let i = 0; i < seatPositions.length; i++) {
        allCards.push({
          id: `deal-r${round}-p${i}`,
          toTop: seatPositions[i].top,
          toLeft: seatPositions[i].left,
        })
      }
    }
    setCards(allCards)

    const totalTime = allCards.length * staggerMs + 500
    const t = setTimeout(() => {
      setCards([])
      onComplete?.()
    }, totalTime)
    return () => clearTimeout(t)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {cards.map((card, i) => (
        <motion.div
          key={card.id}
          className="absolute z-30 w-[36px] h-[50px] rounded-md overflow-hidden shadow-xl pointer-events-none"
          initial={{
            top: "35%",
            left: "50%",
            x: "-50%",
            y: "-50%",
            scale: 0.5,
            opacity: 1,
          }}
          animate={{
            top: card.toTop,
            left: card.toLeft,
            scale: 0.7,
            opacity: [1, 1, 0.6, 0],
          }}
          transition={{
            delay: i * (staggerMs / 1000),
            duration: 0.35,
            ease: [0.22, 0.68, 0.36, 1],
          }}
        >
          <img
            src="/cards/deck/card_back.svg"
            alt=""
            className="w-full h-full object-cover"
            draggable={false}
          />
        </motion.div>
      ))}
    </>
  )
}
